import React, { createContext, useCallback, useState } from 'react';

import { FLASH_MESSAGE_TYPES } from 'constants/common';
import FlashMessage from 'components/FlashMessage';

type FlashMessageContextType = {
  showFlashMessage: (type: FLASH_MESSAGE_TYPES, message: string) => void;
  hideFlashMessage: () => void;
};

export const FlashMessageContext = createContext<FlashMessageContextType>({
  showFlashMessage: () => {
    throw Error('No provider has been provided in the upper scope.');
  },
  hideFlashMessage: () => {
    throw Error('No provider has been provided in the upper scope.');
  },
});

const FlashMessageProvider = ({ children }) => {
  const [flashMessageVisible, setFlashMessageVisible] = useState(false);
  const [flashMessageType, setFlashMessageType] = useState<FLASH_MESSAGE_TYPES | null>(null);
  const [flashMessage, setFlashMessage] = useState<string | null>(null);

  const showFlashMessage = useCallback((type: FLASH_MESSAGE_TYPES, message: string) => {
    setFlashMessageVisible(true);
    setFlashMessageType(type);
    setFlashMessage(message);
  }, []);

  const hideFlashMessage = useCallback(() => {
    setFlashMessageVisible(false);
    setFlashMessageType(null);
    setFlashMessage(null);
  }, []);

  return (
    <FlashMessageContext.Provider value={{ showFlashMessage, hideFlashMessage }}>
      {flashMessageVisible ? (
        <FlashMessage
          visible={flashMessageVisible}
          type={flashMessageType}
          text={flashMessage}
          onClose={() => hideFlashMessage()}
        />
      ) : null}
      {children}
    </FlashMessageContext.Provider>
  );
};

export default FlashMessageProvider;
